<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="actionType=='fields'?'字段权限':'维度权限'"
        :close-on-press-escape="false"
        width="800px"
        append-to-body
        :before-close="handleClose">
        <div class="content-box">
            <div v-if="isMultipleCol">
                <el-checkbox
                    :indeterminate="checkAllIndeterminate"
                    :value="isCheckAll"
                    @change="handleCheckAll">
                    <span>全选</span>
                </el-checkbox>
            </div>
            <div class="group-item-1" :class="isMultipleCol?'multiple-col pl20':''" v-for="group1 in fieldsData" :key="group1.id">
                <div class="group-title mt10 mb10">
                    <el-checkbox
                        :indeterminate="group1.indeterminate"
                        :disabled="group1.disabled||isView"
                        v-model="group1.checked"
                        @change="handleCheck(group1.id, $event)">
                        <span>{{group1.display_name}}</span>
                    </el-checkbox>
                </div>
                <div class="group-content">
                    <template v-for="group2 in group1.children">
                        <div class="test222 ml20" v-if="group2.children&&group2.children.length>0">
                            <div class="group-title mt10 mb10">
                                <el-checkbox
                                    :indeterminate="group2.indeterminate"
                                    :disabled="group2.disabled||isView"
                                    v-model="group2.checked"
                                    @change="handleCheck(group2.id, $event)">
                                    <span>{{group2.display_name}}</span>
                                </el-checkbox>
                            </div>
                            <div class="group-content">
                                <template v-for="group3 in group2.children">
                                    <div class="test222 ml20" v-if="group3.children&&group3.children.length>1">

                                    </div>
                                    <el-checkbox
                                        class="ml40 mb6"
                                        v-else
                                        :disabled="group3.disabled||isView"
                                        :indeterminate="group3.indeterminate"
                                        v-model="group3.checked"
                                        @change="handleCheck(group3.id, $event)">
                                        <span>{{group3.display_name}}</span>
                                    </el-checkbox>
                                </template>
                            </div>
                        </div>
                        <el-checkbox
                            class="ml40 mb6"
                            v-else
                            :indeterminate="group2.indeterminate"
                            :disabled="group2.disabled||isView"
                            v-model="group2.checked"
                            @change="handleCheck(group2.id, $event)">
                            <span>{{group2.display_name}}</span>
                        </el-checkbox>
                    </template>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer tac" v-if="isView">
            <el-button type="default" @click="handleClose" class="action-btn mr20">关闭</el-button>
        </div>
        <div slot="footer" class="dialog-footer tac" v-else>
            <el-button type="default" @click="cancelSubmit" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>

    import util from '@/libs/utils';

    export default {
        name: "RoleFields2",
        components: {},
        props: {
            fields: {
                type: Array,
                required: true
            },
            page:{
                type: Object,
                required: true
            },
            isView:{
                type: Boolean,
                required:true,
            },
            actionType:{
                type: String,
                required: true
            }
        },
        watch: {
            fields: {
                handler(new_value) {
                    if(Array.isArray(new_value)&&new_value.length>0){
                        this.fieldsData = this._fmtTreeData(util.deepClone(new_value));
                        this.oldData = this._fmtTreeData(util.deepClone(this.fieldsData));
                    }
                },
                deep: true,
                immediate: true
            }
        },
        data() {
            return {
                dialogVisible: false,
                fieldsData: this.fields,
                oldData:[],
                curErrMsg:null,
            }
        },
        computed: {
            isMultipleCol(){
                /* 特殊页面需要把维度改为一行多列： 苹果渠道下的系列广告组、系列广告*/
                let spePageList = [
                    'apple_org',
                    'apple_campaign',
                    'apple_adgroup',
                    'apple_keyword',
                    'apple_search_term',
                    'apple_negative_keyword',
                ];
                return this.actionType=='dimensions'&&spePageList.includes(this.page.name);
            },
            isCheckAll(){
                return this.fieldsData.every(item=>item.checked);
            },
            checkAllIndeterminate(){
                return this.fieldsData.some(item=>item.checked)&&this.fieldsData.some(item=>!item.checked);
            },
        },
        mounted() {
        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
            },
            showModal() {
                this.dialogVisible = true;
            },
            resetData() {
                this.fieldsData =  this._fmtTreeData(util.deepClone(this.oldData));
            },
            handleCheck(id, val) {
                let targetCheck = this._findModuleById(this.fieldsData, id);
                let isRequiredFields = targetCheck.default_check==='1';

                /*根节点：没有父级*/
                let isRoot = !this._findModuleById(this.fieldsData,targetCheck.pid);

                /* 叶节点：没有children为叶节点 */
                let isLeaf = !targetCheck.children||((targetCheck.children||[]).length<=0);

                if(isLeaf){
                    if(isRequiredFields){
                        if(this.curErrMsg){
                            this.curErrMsg.close();
                        }
                        this.curErrMsg = this.$message.error('【'+targetCheck.display_name+'】字段为必选项');
                        this.$set(targetCheck,'checked',true);
                        // this._setParentChecked(targetCheck);
                    }else{
                        this.$set(targetCheck,'checked',val);
                    }
                    this._setParentChecked(targetCheck);
                    this._setParentIndeterminate(targetCheck);
                }else if(isRoot){
                    if(isRequiredFields){
                        if(this.curErrMsg){
                            this.curErrMsg.close();
                        }
                        this.curErrMsg = this.$message.error('【'+targetCheck.display_name+'】为必选项');
                        // this.$set(targetCheck,'checked',true);
                        this.$set(targetCheck,'indeterminate',false);
                        this._setChildrenChecked(targetCheck,true);
                    }else{
                        this.$set(targetCheck,'indeterminate',false);
                        this._setChildrenChecked(targetCheck,val);
                    }

                }else{
                    /*又有父节点，又有子节点*/

                    this._setChildrenChecked(targetCheck,val);
                    this._setParentChecked(targetCheck);
                    this._setParentIndeterminate(targetCheck);
                }
            },
            cancelSubmit(){
                this.dialogVisible = false;
                this.resetData();
            },
            handleSubmit() {
                // console.log('save-fields',this.page,this.fieldsData)
                let actionIds = this._getCheckedVal(this.fieldsData,[]);
                this.oldData = this._fmtTreeData(util.deepClone(this.fieldsData));
                this.$emit('save-fields',this.page,actionIds,this.actionType);
                this.handleClose();
            },
            handleCheckAll(val){
                this.fieldsData.forEach(item=>{
                    if(item.default_check!='1'){
                        item.checked = val;
                    }
                })
            },
            _findModuleById(data, id) {
                for (let item in data) {
                    if (data[item].id == id) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findModuleById(child, id);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
            _setParentIndeterminate(module){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(childFields.length>0) {
                   if(childFields.every(field => field.indeterminate===undefined)){
                       if(module.checked===true){
                           this.$set(module,'indeterminate',false);
                       }else{
                           this.$set(module,'indeterminate',childFields.some(field => field.checked)&&childFields.some(field => !field.checked));
                       }
                   }else{
                       if(childFields.some(field => field.indeterminate)) {
                           this.$set(module,'indeterminate',true);
                       }else if(childFields.every(field => field.checked)||childFields.every(field => !field.checked)){
                           this.$set(module,'indeterminate',false);
                       }else{
                           this.$set(module,'indeterminate',true);
                       }
                   }
                }
                let pid = module.pid;
                let pModule = this._findModuleById(this.fieldsData,pid);
                if(pModule){
                    this._setParentIndeterminate(pModule);
                }
            },
            _setParentChecked(module){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(childFields.length>0) {
                    let val = childFields.length > 0 && childFields.some(field => field.checked);
                    this.$set(module,'checked',val);
                }
                let pid = module.pid;
                let pModule = this._findModuleById(this.fieldsData,pid);
                if(pModule){
                    this._setParentChecked(pModule);
                }
            },
            _setChildrenChecked(module,val){
                let childFields = (module.children||[]).filter(item=>!item.disabled);
                if(val){
                    module.checked = val;
                    if(module.indeterminate!==undefined){
                        module.indeterminate = false;
                    }
                }else{
                    if(module.default_check=='1'){
                        if(this.curErrMsg){
                            this.curErrMsg.close();
                        }
                        this.curErrMsg = this.$message.error('【'+module.display_name+'】字段为必选项');
                        module.checked = true;
                        if(module.indeterminate!==undefined){
                            module.indeterminate = true;
                        }else{
                            this.$nextTick(()=>{
                                let pModule = this._findModuleById(this.fieldsData,module.pid);
                                if((pModule.children||[]).every(item=>item.checked===true)){
                                    this.$set(pModule,'checked',true);
                                }
                                this._setParentIndeterminate(pModule);
                            })
                        }
                    }else{
                        module.checked = val;
                        if(module.indeterminate!==undefined){
                            module.indeterminate = childFields.some(item=>item.default_check=='1');
                        }else{
                            module.indeterminate = false;
                        }
                    }
                }
                childFields.forEach(item=>{
                    this._setChildrenChecked(item,val);
                });
            },
            _fmtTreeData(data) {
                data.forEach((v) => {
                    let childFields = v.children||[];
                    if(childFields.some(field => field.indeterminate)||(childFields.some(field => field.checked) && childFields.some(field => !field.checked))){
                        this.$set(v, 'indeterminate', true);
                    }
                    if (childFields.length > 0) {
                        let pageName = (this.page||{}).name||'';
                        if(pageName=='daily_task_page'&&this.actionType=='dimensions'){
                            if(v.checked===undefined){
                                this.$set(v, 'checked', childFields.length > 0 && childFields.every(field => field.checked));
                            }
                            if(v.indeterminate===undefined){
                                this.$set(v, 'indeterminate', childFields.some(field => field.checked) && childFields.some(field => !field.checked));
                            }
                        }
                        
                        // if(v.checked===undefined){
                        //     this.$set(v, 'checked', childFields.length > 0 && childFields.every(field => field.checked));
                        // }
                        // if(v.indeterminate===undefined){
                        //     this.$set(v, 'indeterminate', childFields.some(field => field.checked) && childFields.some(field => !field.checked));
                        // }
                        this._fmtTreeData(childFields)
                    }
                });
                return data;
            },
            _getCheckedVal(list,result){
                list.forEach(item=>{
                    if(item.checked){
                        result.push(item.id);
                    }
                    if(item.children&&item.children.length>0){
                        return this._getCheckedVal(item.children,result);
                    }
                });
                return result;
            },
        }
    }
</script>

<style scoped>
    .content-box{
        max-height: 320px;
        overflow-y: auto;
    }
    .action-btn {
        width: 120px;
    }

    .group-title {
        font-weight: bold;
    }

    .field-checkbox {
        margin: 5px 10px;
        width: 120px;
        white-space: nowrap;
    }

    .multiple-col{
        display: inline-block;
        min-width: 180px;
    }
</style>
